
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-chatgpt-ui",
      function () {
        return require("private-next-pages/best-chatgpt-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-chatgpt-ui"])
      });
    }
  